export const environment = {
  production: true,
  apiUrl: 'https://backend.femmepalette.com',
  certUrl: 'https://certificate.femmepalette.com',
  googleClientId: '733370642435-d8saqh5491mgpd4hlf56qe9gp6o7vf3q.apps.googleusercontent.com',
  linkedinClientId: '77qeorqy77xyul',
  linkedinState: '1234567890',
};
